<template>
	<div class="card">
		<div class="card-header">Obchody a pohyby na majetkovom účte</div>
		<div class="card-body trades-wrapper pt-3 pl-0 pr-0">
            <Loading v-if="loading"/>
			<data-grid :items="items" :columns="columns" :on-detail-open="loadDetail" v-else>
				<template slot="amount" slot-scope="{ item }">
					<span :class="{ 'text-success': item.amount >= 0, 'text-danger': item.amount < 0 }">
						{{ item.amount | number }}
					</span>
				</template>
                <template slot="rate" slot-scope="{ item }">
                    {{ item.rate | number }}
                </template>
				<template slot="dealDate" slot-scope="{ item }">
					{{ item.dealDate | date }}
				</template>
				<template slot="price" slot-scope="{ item }">
					{{ item.price | number(null) }}
				</template>
				<template slot="volume" slot-scope="{ item }">
					{{ item.volume | number(null) }}
				</template>
				<template slot="detail" slot-scope="{ item }">
                    <Loading v-if="!item.detail" class="mb-5 p-5"/>
					<div class="pt-3 pb-3" v-if="item.detail">
						<strong>Podrobnosti</strong>
						<div class="row">
							<div class="col-12 col-md-4 details-wrapper">
								<div class="row">
									<div class="col-md-6">Poplatok za vysporiadanie:</div>
									<div class="col-md-6">{{ item.detail.settlementFee | number }} {{ item.currency }}</div>
								</div>
								<div class="row">
									<div class="col-md-6">Poplatok za obchod:</div>
									<div class="col-md-6">{{ item.detail.dealFee | number }} {{ item.currency }}</div>
								</div>
								<div class="row">
									<div class="col-md-6">Poplatok tretej strany:</div>
									<div class="col-md-6">{{ item.detail.partnerFee | number }} {{ item.currency }}</div>
								</div>
							</div>
							<div class="col-12 col-md-4 details-wrapper">
								<div class="row">
									<div class="col-md-6">ISIN:</div>
									<div class="col-md-6">{{ item.detail.isin }}</div>
								</div>
								<div class="row">
									<div class="col-md-6">Odvetvie:</div>
									<div class="col-md-6">{{ item.detail.industry }}</div>
								</div>
								<div class="row">
									<div class="col-md-6">Typ aktíva:</div>
									<div class="col-md-6">{{ item.detail.type }}</div>
								</div>
							</div>
							<div class="col-12 col-md-4 details-wrapper">
								<div class="row">
									<div class="col-md-6">Dátum pohybu:</div>
									<div class="col-md-6">{{ item.detail.dealDate | date }}</div>
								</div>
								<div class="row">
									<div class="col-md-6">Dátum vysporiadania:</div>
									<div class="col-md-6">{{ item.detail.settlementDate | date }}</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</data-grid>
            <Loading v-if="!loading && loadingNext"/>
		</div>
	</div>
</template>

<script>
import DataGrid from "../../../components/DataGrid";
import Loading from "../../../components/Loading";

export default {
	name: "Trades",
	components: {
		DataGrid,
        Loading
	},
	props: {
		portfolio: {
			type: String | null,
			required: false,
			default: null,
		},
	},
	watch: {
		portfolio() {
			this.page = 1;
			this.loadData();
		},
		from() {
			this.page = 1;
			this.loadData();
		},
		to() {
			this.page = 1;
			this.loadData();
		},
	},
	computed: {
		items() {
			return this.$store.state.transactions.trades;
		},
		loading() {
			return this.$store.state.transactions.loading;
		},
        loadingNext() {
            return this.$store.state.transactions.loadingNext;
        },
		from() {
			return this.$store.state.transactions.from;
		},
		to() {
			return this.$store.state.transactions.to;
		},
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData() {
            this.$store.commit("transactions/resetTradeDetails");
			this.$store.dispatch("transactions/trades", {
				page: this.page,
				append: true,
				portfolioId: this.portfolio,
				from: this.from,
				to: this.to,
			});
		},
		loadDetail(trade, index) {
			this.$store.dispatch("transactions/tradeDetail", { id: trade.dealId, index });
		},
		nextPage() {
			this.page += 1;
			this.loadData();
		},
	},
	data() {
		return {
			columns: [
				{
					name: "Dátum pohybu",
					slug: "dealDate",
				},
				{
					name: "Portfólio",
					slug: "portfolio",
				},
				{
					name: "Typ pohybu",
					slug: "transactionType",
				},
				{
					name: "Aktívum",
					slug: "asset",
				},
				{
					name: "Počet",
					slug: "volume",
				},
				{
					name: "Cena",
					slug: "rate",
				},
				{
					name: "Objem",
					slug: "price",
				},
				{
					name: "Mena",
					slug: "currency",
				},
			],
		};
	},
};
</script>

<style lang="scss">
    @import "@/assets/styles/variables.scss";

    .trades-wrapper table {
        font-size: 13px !important;

        @include media-breakpoint-down(lg) {
            font-size: 11px !important;
        }
    }
</style>
